module.exports = __webpack_public_path__ + "img/main-block-product-showcase-marketing.ba1758ed.svg";